import React from 'react';
import {Outlet} from 'react-router-dom';
import AdminLayout from "../../../layout/admin/AdminLayout";

const Pages: React.FC = () => {
  return (
    <AdminLayout>
      <Outlet/>
    </AdminLayout>
  );
};

export default Pages;

